import React from 'react';
import { ArrowRight, Heart, ShieldCheck } from 'lucide-react';

/**
 * Patient-facing right rail on the Connect page (lg+ desktop only).
 * Replaces the previous platform-metrics card which had zero value to a
 * patient mid-flow. Now keeps the surface entirely patient-empathetic:
 * "Here's why DocSite is for you" + a single deep-link to /for-patients.
 *
 * Mobile/tablet hide this rail to preserve the form-first flow.
 */
export default function PatientSideCard() {
  return (
    <aside
      className="hidden lg:block w-[320px] xl:w-[360px]"
      aria-label="Why DocSite is for patients"
      data-testid="patient-side-card"
    >
      <div className="sticky top-6 space-y-3">
        <a
          href="/for-patients"
          target="_blank"
          rel="noopener noreferrer"
          className="block rounded-3xl border border-sky-200 bg-gradient-to-br from-sky-50 to-emerald-50 p-5 hover:border-sky-300 transition-colors group"
          data-testid="patient-side-cta"
        >
          <div className="flex items-center gap-2 mb-2">
            <Heart size={14} className="text-rose-500" />
            <p className="text-[10px] uppercase tracking-[0.2em] font-bold text-sky-700">DocSite is built for patients too</p>
          </div>
          <p className="text-sm font-semibold text-slate-900 leading-snug" style={{ fontFamily: 'Outfit, sans-serif' }}>
            One place for every doctor you visit — your full visit history, follow-ups, and reports.
          </p>
          <p className="text-xs text-slate-600 mt-2 leading-relaxed">
            No middlemen. No spam calls. No re-explaining your story at every clinic.
          </p>
          <span className="inline-flex items-center gap-1 mt-3 text-xs font-semibold text-sky-700 group-hover:text-sky-900">
            Why patients love DocSite <ArrowRight size={12} />
          </span>
        </a>

        <div className="rounded-2xl border border-slate-200 bg-white/70 p-3" data-testid="patient-side-trust">
          <p className="text-[10px] text-slate-500 leading-relaxed flex items-start gap-1.5">
            <ShieldCheck size={11} className="text-emerald-600 mt-0.5 shrink-0" />
            Your details stay private with the doctor. DocSite never resells, never directories, never auctions patient lists.
          </p>
        </div>
      </div>
    </aside>
  );
}
